module.exports = __webpack_public_path__ + "static/media/S3N3-2.d04d95dc.svg";